import { Alert, Button, List, Text } from '@mantine/core';

/** A plain sentence when something fails. Never a status code, never a stack trace. */
export function ErrorNote({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <Alert role="alert" color="red" variant="light" radius="md" my="md">
      <Text size="sm">{message}</Text>
      {onRetry !== undefined && (
        <Button variant="subtle" color="red" size="compact-sm" mt="xs" onClick={onRetry} px={0}>
          Try again
        </Button>
      )}
    </Alert>
  );
}

/**
 * The list of things to fix before a poll can be saved.
 *
 * The heading is a prop because the same list is used where saving is not what happens next, and a
 * list of problems under the wrong sentence is worse than no sentence at all.
 */
export function ProblemList({
  problems,
  title = 'Before you can save:',
}: {
  problems: readonly string[];
  title?: string;
}) {
  if (problems.length === 0) return null;
  return (
    <Alert role="alert" color="red" variant="light" radius="md" my="md">
      <Text size="sm" fw={500}>
        {title}
      </Text>
      <List size="sm" mt="xs" spacing={4}>
        {problems.map((problem) => (
          <List.Item key={problem}>{problem}</List.Item>
        ))}
      </List>
    </Alert>
  );
}
